var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SharedSummary',{attrs:{"meta-data":_vm.metaData},scopedSlots:_vm._u([{key:"images",fn:function(){return [_c('SatelliteImageReference',{attrs:{"image":_vm.metaData.parameters.selectedImage}})]},proxy:true},{key:"availableimages",fn:function(ref){
var image = ref.image;
return [_c('SatelliteImageReference',{attrs:{"image":image}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }